import { getValue } from "@utils/lodash";
import { formHandleTextArrayChangeByKey } from "@common/handleChange";
import CloseSmallSvgComponent from "@assets/svg-components/close-small";
import InputField from "@common/InputRuleFeild";
import TripCityComponent from "../common/trip_city";
import TripDateComponent from "../common/trip_date";
import AddSvgComponent from "@assets/svg-components/add";
import { toast } from "react-toastify";

function TripCreateBusSection(props: any) {
  /* -------------------------------------------------------------------------- */
  /*                               Car CRUD Section                             */
  /* -------------------------------------------------------------------------- */
  const addSection = () => {
    let obj = {
      departure_date: "",
      departure_city: "",
      departure_city_name: "",
      departure_location: "",
      arrival_city: "",
      arrival_city_name: "",
      arrival_location: "",
      // is_personal_travel: false,
    };
    props.itenaries.push(obj);
    props.setItenaries([...props.itenaries]);
  };
  const removeSection = (index: number) => {
    let filtered =
      getValue(props, `itenaries.length`, 0) > 0
        ? getValue(props, `itenaries`, []).filter(
            (item: object, i: number) => index !== i
          )
        : [];
    props.setItenaries(filtered);
    props.hideValidation();
  };
  return (
    <div>
      <div className="trips-bus-tab-main-container">
        {" "}
        {/*px-4 mt-4 w-100*/}
        <div className="mt-4">
          {getValue(props, `itenaries.length`, 0) > 0 ? (
            getValue(props, `itenaries`, []).map(
              (item: object, index: number) => {
                return (
                  <div className="multiple-dyno-wrap">
                    <div className="d-flex justify-content-sm-between align-items-center w-100">
                      <div className="w-100">
                        <div className="d-flex flex-wrap_wrap">
                          <div className="">
                            <TripCityComponent
                              item={item}
                              index={index}
                              validator={props.validator}
                              setItenaries={props.setItenaries}
                              label={"Departure City"}
                              city_key={"departure_city"}
                              city_name_key={"departure_city_name"}
                              locationIcon
                            />
                            {getValue(item, `departure_city`, "") && (
                              <div className="mt-3" style={{ width: "350px" }}>
                                <InputField
                                  inputType="TEXT"
                                  label="Location"
                                  placeholder="Enter departure location details"
                                  name="departure_location"
                                  value={getValue(
                                    item,
                                    `departure_location`,
                                    ""
                                  )}
                                  onChange={(e: any) =>
                                    formHandleTextArrayChangeByKey(
                                      index,
                                      e,
                                      props.setItenaries
                                    )
                                  }
                                />
                              </div>
                            )}
                          </div>
                          <div className="">
                            <TripCityComponent
                              item={item}
                              index={index}
                              validator={props.validator}
                              setItenaries={props.setItenaries}
                              label={"Arrival City"}
                              city_key={"arrival_city"}
                              city_name_key={"arrival_city_name"}
                              locationIcon
                            />
                            {getValue(item, `arrival_city`, "") && (
                              <div className="mt-3" style={{ width: "350px" }}>
                                <InputField
                                  inputType="TEXT"
                                  label="Location"
                                  placeholder="Enter arrival location details"
                                  name="arrival_location"
                                  value={getValue(item, `arrival_location`, "")}
                                  onChange={(e: any) =>
                                    formHandleTextArrayChangeByKey(
                                      index,
                                      e,
                                      props.setItenaries
                                    )
                                  }
                                />
                              </div>
                            )}
                          </div>
                          <div className="">
                            <TripDateComponent
                              validator={props.validator}
                              item={item}
                              index={index}
                              date_key={"departure_date"}
                              setItenaries={props.setItenaries}
                              label={"Departure Date"}
                            />
                          </div>
                        </div>
                        <div className="flight_description_wrap mb-16">
                          <InputField
                            inputType="TEXTAREA"
                            placeholder="Special request / Client location / Preferred hotel (Max 200 Characters)"
                            rows={2}
                            name="description"
                            value={getValue(item, `description`, "")}
                            // onChange={(e: any) =>
                            //   formHandleTextArrayChangeByKey(
                            //     index,
                            //     e,
                            //     props.setItenaries
                            //   )
                            // }
                            onChange={(e: any) => {
                              const { value } = e.target;
                              if (value.length <= 200) {
                                formHandleTextArrayChangeByKey(
                                  index,
                                  e,
                                  props.setItenaries
                                );
                              } else {
                                toast.error("Character Limit should be 200");
                              }
                            }}
                          />
                        </div>
                      </div>
                      <div
                        className=" mt-2"
                        onClick={() => removeSection(index)}
                      >
                        <CloseSmallSvgComponent />
                      </div>
                    </div>
                  </div>
                );
              }
            )
          ) : (
            <div className="mt-5">
              <div className="trips_header_bg d-flex align-items-center p-2 px-4 mt-4">
                <h6 className="header_text__18 ">Bus</h6>
              </div>
              <p className="text-center small_text__14 mt-3">
                No Bus have been included. Kindly select the option below to add
                them.
              </p>
              <div
                className="d-flex justify-content-center align-items-center cursor-pointer  mt-3"
                onClick={addSection}
              >
                <div className="border border-radius__5 d-flex justify-content-center p-2 px-3">
                  <AddSvgComponent size={28} color={"#408dfb"} />
                  <h6 className="header_text__18 ms-2 color_primary">
                    Add Bus
                  </h6>
                </div>
              </div>
            </div>
          )}
        </div>
        {getValue(props, `itenaries.length`, 0) > 0 && (
          <div
            className="custom_field_button_container mt-3"
            onClick={addSection}
          >
            <img
              className="custom_field_button_container_image"
              src={`/images/add_circle.svg`}
            />
            <h6 className="header_text__16 color_primary ms-2">
              {getValue(props, `itenaries.length`, 0) > 0 && "Add another bus"}
            </h6>
          </div>
        )}
      </div>
    </div>
  );
}

export default TripCreateBusSection;
